module.exports = __webpack_public_path__ + "static/media/photo271.73c21db0.jpg";